import { createIcon } from './icon-utils';

export const StepperUpIcon = createIcon({
  path: 'M.94 4.825l2.72-2.512c.192-.177.488-.177.68 0l2.72 2.512c.203.187.216.504.029.706-.095.103-.228.161-.368.161H1.28c-.276 0-.5-.224-.5-.5 0-.14.058-.272.16-.367z',
  viewBox: '0 0 8 8',
});
